import { DEFAULT_HEADER, JWT_REFRESH_TOKEN, MEMBER_ID, ADMIN_KIND } from '../const';

export default function authHeader() {
    return {
        ...DEFAULT_HEADER,
        Authorization: localStorage.getItem(JWT_REFRESH_TOKEN) || '',
        memberId: localStorage.getItem(MEMBER_ID) || ''
    };
}
